import clsx from "clsx";
import "./styles.css";
import { ChangeEvent } from "react";

interface Props {
  id: string;
  label?: string;
  disabled?: boolean;
  color?: "primary" | "text";
  selected?: boolean;
  onChange?: (e: ChangeEvent) => void;
}

export const InputDropdownOptionRadio = ({
  id,
  label,
  disabled,
  color = "primary",
  selected = false,
  onChange,
}: Props): JSX.Element => {
  return (
    <div
      className={clsx("input-radio-without-control flex w-full", color, {
        checked: selected,
      })}
    >
      <label htmlFor={id} className={clsx("relative w-full p-2 pr-7", disabled ? "opacity-50" : "cursor-pointer")}>
        {label}
      </label>

      <input
        id={id}
        className="m-0 h-0 w-0 opacity-0"
        type="radio"
        disabled={disabled}
        checked={selected}
        onChange={onChange}
      />
    </div>
  );
};
